export default __webpack_public_path__ + "static/media/ds04.b1a9d93e.jpg";